import { render } from "./edit.vue?vue&type=template&id=c000eadc&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=c000eadc&style=scss&scoped=true&lang=css"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c000eadc"],['__file',"src/views/people/levelIcon/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c000eadc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c000eadc', __exports__)) {
    console.log('reload')
    api.reload('c000eadc', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=c000eadc&scoped=true", () => {
    console.log('re-render')
    api.rerender('c000eadc', render)
  })

}


export default __exports__